import React from "react";
import "./styles.scss";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import AccountCircle from "@material-ui/icons/AccountCircle";
import NotificationsIcon from "@material-ui/icons/Notifications";
import MoreIcon from "@material-ui/icons/MoreVert";
import { useStyles } from "./styles";
import { FaBars } from "react-icons/fa";

const Header = ({
  handleShowSideBar,
  handleShowboxOpen,
  handleProfileMenuOpen,
  noticount,
}) => {
  const classes = useStyles();
  const menuId = "primary-search-account-menu";
  const ShowboxId = "primary-search-account-menu-mobile";

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar>
        <Typography variant="h6" noWrap>
          <FaBars
            onClick={() => handleShowSideBar()}
            style={{ fontSize: "24px", color: "#ccc" }}
          />
        </Typography>
        <div className={classes.grow} />
        <div className={classes.sectionDesktop}>
          <IconButton
            aria-label="show 17 new notifications"
            color="inherit"
            onClick={handleShowboxOpen}
          >
            <Badge badgeContent={noticount} color="secondary">
              <NotificationsIcon />
            </Badge>
          </IconButton>
          <IconButton
            edge="end"
            aria-label="account of current user"
            aria-controls={menuId}
            aria-haspopup="true"
            onClick={handleProfileMenuOpen}
            color="inherit"
          >
            <AccountCircle />
          </IconButton>
        </div>
        <div className={classes.sectionMobile}>
          <IconButton
            aria-label="show more"
            aria-controls={ShowboxId}
            aria-haspopup="true"
            onClick={handleShowboxOpen}
            color="inherit"
          >
            <MoreIcon />
          </IconButton>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
